import React from 'react';
import { getLtsRelatedInfo } from '../utils/ltsCardDetailsUtils';
import PropTypes from 'prop-types';
import LtsContentSection from './LtsContentSection';
function LtsTrainRelatedInfoSection({ trainRelatedInfo }) {
  if (!trainRelatedInfo) {
    return null;
  }
  const LTS_CONTENT = getLtsRelatedInfo(trainRelatedInfo);

  return (
    <div className="appendBottom40">
      {LTS_CONTENT.map((Section) => (
        <LtsContentSection key={Section.key} {...Section} />
      ))}
    </div>
  );
}

LtsTrainRelatedInfoSection.propTypes = {
  trainRelatedInfo: PropTypes.object
};

export default LtsTrainRelatedInfoSection;
